import { AttachedTrait } from '../../attachedtrait/AttachedTrait';
import { MedSeqFile } from './modules/AttachedMedSeqFile';
import { MedSeqInfo } from './modules/AttachedMedSeqInfo';
export class AttachedMedSeqTrait extends AttachedTrait {
    getFile = new MedSeqFile(this);
    info = new MedSeqInfo(this);
}
